module.exports = __webpack_public_path__ + "static/media/screenshot_spaced-repetition.e2e919e5.png";